export function toCents(value: string) {
  if (!/^\d+(\.\d{0,2})?$/.test(value)) {
    return 0n
  }
  const [a, b = ''] = value.split('.')
  return BigInt(a) * 100n + BigInt(b.padEnd(2, '0'))
}
export function fromCents(value: bigint) {
  const negative = value < 0n
  const absolute = negative ? -value : value
  const amount = `${absolute / 100n}.${(absolute % 100n).toString().padStart(2, '0')}`
  return negative ? `-${amount}` : amount
}
